var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestive5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.512,
    height: 47.243,
    viewBox: "0 0 47.512 47.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7637",
    "data-name": "Group 7637",
    transform: "translate(365.159 -880.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    d: "M-343.421,937.186h-21.712c-.009-.184-.024-.351-.024-.519q0-3.76,0-7.521c0-.883.261-1.14,1.157-1.14h19.426c.891,0,1.153.26,1.153,1.145q0,3.76,0,7.521Z",
    transform: "translate(0 -35.447)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    "data-name": "Path 4344",
    d: "M-365.159,1029.832h21.713c.008.179.023.346.023.514q0,3.76,0,7.521c0,.884-.263,1.145-1.154,1.145H-364c-.895,0-1.157-.258-1.158-1.141C-365.159,1035.21-365.159,1032.548-365.159,1029.832Z",
    transform: "translate(0 -111.333)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    d: "M-343.323,970.82v13.316h-21.672V970.82Zm-10.839,5.7c-.161-.258-.265-.436-.381-.608a7.425,7.425,0,0,0-6.165-3.449c-.607-.025-.975.282-.975.836a21.284,21.284,0,0,0,.091,2.761,7.488,7.488,0,0,0,6.878,6.416,7.568,7.568,0,0,0,7.757-5.351,12.479,12.479,0,0,0,.3-3.885c-.01-.5-.382-.783-.927-.779a7.281,7.281,0,0,0-3.029.688A7.673,7.673,0,0,0-354.162,976.52Z",
    transform: "translate(-0.122 -67.354)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    d: "M-336.883,882.192v3.283h-14.983v-3.283Z",
    transform: "translate(-9.907 -1.304)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    d: "M-342.089,906.806v-4.955h9.967v4.955Z",
    transform: "translate(-17.193 -15.955)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    "data-name": "Path 4348",
    d: "M-261.141,885.3l-3.484,3.493a.2.2,0,0,1-.1-.041c-1.366-1.363-2.741-2.717-4.089-4.1a2.418,2.418,0,0,1-.434-2.8,2.372,2.372,0,0,1,2.414-1.388,2.845,2.845,0,0,1,1.493.632C-263.9,882.451-262.532,883.89-261.141,885.3Z",
    transform: "translate(-71.285 0)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    "data-name": "Path 4349",
    d: "M-220.67,1051.172V1046.2a1.453,1.453,0,0,1,.243-.041c1.877,0,3.755-.017,5.632,0a2.491,2.491,0,0,1,2.463,2.465,2.468,2.468,0,0,1-2.337,2.529C-216.65,1051.2-218.631,1051.172-220.67,1051.172Z",
    transform: "translate(-107.681 -123.498)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    "data-name": "Path 4350",
    d: "M-251.81,1051.167c-2.022,0-4.006.035-5.989-.012a2.47,2.47,0,0,1-2.332-2.491,2.47,2.47,0,0,1,2.332-2.49c1.983-.045,3.967-.012,5.989-.012Z",
    transform: "translate(-78.272 -123.494)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4351",
    "data-name": "Path 4351",
    d: "M-208.04,941.413l-3.574-3.575c.224-.208.482-.433.725-.675,1.1-1.092,2.187-2.195,3.291-3.282a2.557,2.557,0,0,1,3.655-.091,2.509,2.509,0,0,1-.116,3.64C-205.382,938.763-206.714,940.087-208.04,941.413Z",
    transform: "translate(-114.43 -39.218)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    "data-name": "Path 4352",
    d: "M-232.35,1004.8l-3.513,3.5c-.07-.061-.176-.141-.27-.235q-1.849-1.845-3.693-3.695a2.5,2.5,0,0,1-.077-3.637,2.5,2.5,0,0,1,3.6.082c1.251,1.236,2.49,2.485,3.733,3.73C-232.487,1004.636-232.413,1004.73-232.35,1004.8Z",
    transform: "translate(-92.792 -89.113)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4353",
    "data-name": "Path 4353",
    d: "M-208.537,1029.562a11.38,11.38,0,0,0-1.671-1.185,4.808,4.808,0,0,0-1.8-.423c-1.249-.062-2.5-.042-3.753-.008a1.079,1.079,0,0,1-1.1-.532l3.468-3.469c1.425,1.4,2.885,2.81,4.319,4.25A1.894,1.894,0,0,1-208.537,1029.562Z",
    transform: "translate(-110.522 -106.946)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4354",
    "data-name": "Path 4354",
    d: "M-230.5,914.962h1.611v1.62H-230.5Z",
    transform: "translate(-100.356 -25.726)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M-238.708,924.821v1.614h-1.622v-1.614Z",
    transform: "translate(-93.028 -33.073)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    d: "M-227.181,931.387h1.611v1.608h-1.611Z",
    transform: "translate(-102.828 -37.967)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    "data-name": "Path 4357",
    d: "M-240.3,941.224h1.606v1.608H-240.3Z",
    transform: "translate(-93.052 -45.298)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    d: "M-223.935,962.589v-1.6h1.611v1.6Z",
    transform: "translate(-105.247 -60.026)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    "data-name": "Path 4359",
    d: "M-212.427,972.451h-1.6v-1.624h1.6Z",
    transform: "translate(-112.634 -67.359)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    "data-name": "Path 4360",
    d: "M-222.29,982.263H-223.9V980.64h1.613Z",
    transform: "translate(-105.271 -74.672)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    "data-name": "Path 4361",
    d: "M-209.163,987.2v1.6h-1.613v-1.6Z",
    transform: "translate(-115.054 -79.565)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    "data-name": "Path 4362",
    d: "M-340.484,990.794a5.8,5.8,0,0,1-4.947-6.432C-342.79,984.177-340.175,987.556-340.484,990.794Z",
    transform: "translate(-14.678 -77.441)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4363",
    "data-name": "Path 4363",
    d: "M-314.234,984.261a5.77,5.77,0,0,1-4.917,6.458A5.767,5.767,0,0,1-314.234,984.261Z",
    transform: "translate(-34.253 -77.371)",
    fill: "#aceb1e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestive5);
export default __webpack_public_path__ + "static/media/digestive5.4054aeb64d696d91a97c2f15ddfe009f.svg";
export { ForwardRef as ReactComponent };